import { useState, useCallback, useMemo, memo, useEffect } from "react";
import PaytmPayment from "../../../../../../../../../custom_utilities/paytm_payment/PaytmPayment";
import images from "../../../../../../../../../utilities/images/images";
import "./StorePaymentPage.scss";
import CouponList from "../../../../modal/Coupons/CouponList";
import TermsAndCondition from "../../../../modal/TermsAndCondition/TermsAndCondition";
import { useDispatch, useSelector } from "react-redux";
import {
  setOrderId,
  setPaytmDataInStore,
} from "../../../../../../../../../redux/payment_gateway/action";
import { ToastContainer } from "react-toastify";
import { STORE_PRICE_TOAST_CONTAINER_ID } from "../../../../../../../../../custom_utilities/toastify_config";
import { applyCoupon } from "../StoreUtils/StoreApiUtils";
import { Render } from "../../../../../../../../homepage/Render";
import { formatExpiryDate, formatPrice, isPackageSubscribed } from "../StoreUtils/storePackageUtils";
import { trackWebEngageViewCoupons } from "../../../../../../../../../custom_utilities/webengage/webengageService";

const StorePaymentPage = ({
  packageData,
  selectedFrequentPackages,
  selectedPackage,
  selectedPackageId,
  addonDiscount,
  finalAmount,
  setFinalAmount,
  couponCode,
  setCouponCode,
  setCouponDiscount,
  setAddonDiscount,
  startLoading,
  finishLoading,
  couponDiscount,
  selectedRelatedPackages,
}) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.user.user_id);
  const paymentDetails = useSelector((state) => state.paymentReducer.paytmDetails);

  const [showCouponList, setShowCouponList] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [isCouponApplied, setIsCouponApplied] = useState(false);

  useEffect(() => {
    if (String(couponCode || "").length === 0 && isCouponApplied) {
      setIsCouponApplied(false);
      setCouponDiscount("0.00");

      const basePrice =
        (packageData?.price_details?.course_price || 0) -
        (packageData?.price_details?.discount || 0) -
        addonDiscount;

      setFinalAmount(Math.max(0, basePrice).toFixed(2));
    }
  }, [
    couponCode,
    isCouponApplied,
    setCouponDiscount,
    setFinalAmount,
    packageData,
    addonDiscount,
  ]);

 //FINAL ROBUST Total Price - Always trust finalAmount after apply
  const displayTotalPrice = useMemo(() => {
    const finalAmt = Number(finalAmount);

    if (!isNaN(finalAmt) && finalAmt >= 0) {
      return finalAmt.toFixed(2);
    }

    return "0.00";
  }, [finalAmount]);

  const openCouponList = useCallback(() => {
    trackWebEngageViewCoupons();
    setShowCouponList(true);
  }, []);
  const openTerms = useCallback(() => setShowTerms(true), []);
  const handleCloseCoupon = useCallback(() => setShowCouponList(false), []);
  const closeTerms = useCallback(() => setShowTerms(false), []);
  const handleOnChangeCouponCode = useCallback(
    (e) => setCouponCode(e.target.value.toUpperCase()),
    [setCouponCode]
  );

  const checkApplyCouponBtnDisabled = useCallback(
    () => (couponCode.trim().length === 0 ? "disableapplybtn" : ""),
    [couponCode]
  );

  const effectivePrice = useMemo(() => {
    return selectedRelatedPackages
      .reduce((sum, pkg) => {
        const amount = Number(pkg.amount || 0);
        const discount = Number(pkg.discount || 0);
        return sum + (amount - discount);
      }, 0)
      .toFixed(2);
  }, [selectedRelatedPackages]);

  const handleApplyCoupon = useCallback(() => {
    applyCoupon({
      couponCode: couponCode.trim(),
      userId,
      packageId: selectedPackage?.package_id || selectedPackageId,
      selectedPackage,
      packageData,
      setFinalAmount,
      setCouponDiscount,
      setAddonDiscount,
      startLoading,
      finishLoading,
      handleCloseCoupon,
      setIsCouponApplied,
      finalAmount,
      paymentAction: (id) => dispatch(setOrderId(id)),
      setPaytmDataInStore: (data) => dispatch(setPaytmDataInStore(data)),
    });
  }, [
    couponCode,
    userId,
    selectedPackage,
    selectedPackageId,
    packageData,
    setFinalAmount,
    setCouponDiscount,
    setAddonDiscount,
    startLoading,
    finishLoading,
    handleCloseCoupon,
    setIsCouponApplied,
    finalAmount,
    dispatch,
  ]);

  const handleRemoveCoupon = useCallback(() => {
    setCouponCode("");
    setCouponDiscount("0.00");
    setIsCouponApplied(false);
    dispatch(setOrderId(""));

    const basePrice =
      (packageData?.price_details?.course_price || 0) -
      (packageData?.price_details?.discount || 0) -
      addonDiscount;

    setFinalAmount(Math.max(0, basePrice).toFixed(2));
  }, [
    setCouponCode,
    setCouponDiscount,
    setFinalAmount,
    packageData,
    addonDiscount,
    dispatch,
  ]);

  const formattedDate = useMemo(
    () => formatExpiryDate(packageData?.PackageInstallmentDetails?.date_expiry),
    [packageData]
  );

  const shouldShowExpiryDate = !!formattedDate;

  const isPurchased = useMemo(
    () => isPackageSubscribed(packageData?.PackageInstallmentDetails),
    [packageData]
  );

  const showPayment = !isPurchased && displayTotalPrice !== "0.00";

  if (isPurchased) {
    return (
      <div
        className="user-dashboard-coupon-referral-wrapperr purchased-package-sidebar"
        style={{ marginTop: "30px" }}
      >
        <div className="purchased-package-badge">Purchased</div>
        {shouldShowExpiryDate && (
          <div className="validity">
            Valid up to <span>{formattedDate}</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="user-dashboard-coupon-referral-wrapperr" style={{ marginTop: "30px" }}>
      <div className="header_store_page">
        <div className="title--">
          <img src={images.coupon} alt="coupon icon" />
          <span>Coupon/Referral</span>
          <button className="view-coupons--" onClick={openCouponList}>
            View Coupons
          </button>
        </div>
      </div>

      <div className="coupon-input">
        <input
          type="text"
          placeholder="Enter Coupon/Referral Code"
          value={couponCode}
          onChange={handleOnChangeCouponCode}
        />
        <button
          onClick={isCouponApplied ? handleRemoveCoupon : handleApplyCoupon}
          className={
            isCouponApplied ? "remove-coupon-btn" : checkApplyCouponBtnDisabled()
          }
        >
          {isCouponApplied ? "Remove" : "Apply"}
        </button>
      </div>

      <div className="price-details">
        <h3>Price Details</h3>

        <div className="price-row">
          <span>Course Price</span>
          <span>₹{formatPrice(packageData?.price_details?.course_price)}</span>
        </div>

        <div className="price-row">
          <span>Addons Course</span>
          <span>₹{formatPrice(effectivePrice)}</span>
        </div>

        <div className="price-row">
          <span>Discount</span>
          <span className="discount">
            - ₹{formatPrice(packageData?.price_details?.discount)}
          </span>
        </div>

        <div className="price-row">
          <span>Coupon Discount</span>
          <span className="discount">- ₹{formatPrice(couponDiscount)}</span>
        </div>

        {Number(addonDiscount) > 0 && (
          <div className="price-row">
            <span>Addons Discount</span>
            <span className="discount">- ₹{formatPrice(addonDiscount)}</span>
          </div>
        )}

        <div className="price-details-toast-slot">
          <ToastContainer
            enableMultiContainer
            containerId={STORE_PRICE_TOAST_CONTAINER_ID}
            className="price-details-toast-container"
            toastClassName="price-details-toast"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable={false}
            newestOnTop
            limit={1}
          />
        </div>

        <div className="price-row total">
          <span>Total Price</span>
          <span>₹{formatPrice(displayTotalPrice)}</span>
        </div>
      </div>

      <div className="terms" onClick={openTerms}>
        <img src={images?.phInfo} alt="info" />
        Terms & Conditions
      </div>

      <Render if={showPayment}>
        <PaytmPayment
          addon_products={selectedFrequentPackages}
          packageDetails={{
            ...(packageData?.package_quick_variants?.show_quick_variants_selection_type ===
            2
              ? selectedPackage
              : packageData?.PackageInstallmentDetails),
            package_id:
              selectedPackage?.package_id || selectedPackageId,
          }}
          amount={displayTotalPrice}
          couponCode={isCouponApplied ? couponCode : ""}
          buttonText="Proceed to Pay"
          buttonClass="store_pay_now"
        />
      </Render>

      {shouldShowExpiryDate && (
        <div className="validity">
          Valid up to <span>{formattedDate}</span>
        </div>
      )}

      {showCouponList && (
        <CouponList
          userId={userId}
          package_id={selectedPackage?.package_id}
          paymentDetails={paymentDetails}
          packageData={packageData}
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          applyCoupon={handleApplyCoupon}
          handleCloseCoupon={handleCloseCoupon}
          checkApplyCouponBtnDisabled={checkApplyCouponBtnDisabled}
          handleOnChangeCouponCode={handleOnChangeCouponCode}
        />
      )}

      {showTerms && (
        <TermsAndCondition
          handleClose={closeTerms}
          terms={packageData?.terms_conditions}
        />
      )}
    </div>
  );
};

export default memo(StorePaymentPage);